module.exports = __webpack_public_path__ + "assets/img/facergt-app2.acea0f4f.png";